import { gsap, Power2 } from 'gsap';

export default {
  animateIn(i, section) {
    if (!section.classList.contains('c-section-parallax')) return;

    const contentTween = gsap.timeline();
    const heading = section.querySelector('.c-section-parallax__subheading');
    const text = section.querySelector('.c-section-parallax__content-text');
    const imageMobile = section.querySelector('.c-section-parallax__content-image--mobile');
    const imageDesk = section.querySelector(
      '.c-section-parallax__content-image:not(.c-section-parallax__content-image--mobile)'
    );
    contentTween
      .from(heading, 0.8, { autoAlpha: 0, y: -100, ease: Power2.easeOut }, 0.2)
      .from(imageMobile, 0.8, { autoAlpha: 0, y: i === 1 ? 150 : 0, x: -150, ease: Power2.easeOut }, 0.35)
      .from(imageDesk, 0.8, { autoAlpha: 0, y: i === 1 ? 150 : 0, x: -150, ease: Power2.easeOut }, 0.35)
      .from(text, 0.8, { autoAlpha: 0, x: 50, ease: Power2.easeOut }, 0.5);
  },
};
